import shallow from "zustand/shallow";
import useCompanySearchStore from "stores/use-company-search-store";
import type { TagLinkProps } from "components/common/link/tag-link";
import TagLink from "components/common/link/tag-link";
import PermissionField from "components/common/permission-field";
import colorSchemes from "data/color-schemes";
import type { KeywordItem } from "types/api/search/industry-keyword";

interface KeywordTagProps extends TagLinkProps {
  keyword: string;
  keywordId?: number;
  shouldIncludeLink?: boolean;
  hasPermission?: boolean;
}

const KeywordTag = ({
  keyword,
  keywordId,
  shouldIncludeLink = false,
  hasPermission = true,
  ...props
}: KeywordTagProps) => {
  const { resetCompanyFilters, updateCompanyFilter, getCompanySearch } =
    useCompanySearchStore(
      (store) => ({
        resetCompanyFilters: store.resetFilters,
        updateCompanyFilter: store.updateFilter,
        getCompanySearch: store.getSearch,
      }),
      shallow
    );

  // Navigate to the search on keyword click and set that keyword in the search
  const handleKeywordClick = () => {
    resetCompanyFilters();
    const newSelectedCompanyKeywords: KeywordItem[] = [
      { id: keywordId, name: keyword },
    ];
    updateCompanyFilter("selectedKeywords", newSelectedCompanyKeywords);
    getCompanySearch();
  };

  const willIncludeLink = shouldIncludeLink && !!keywordId && hasPermission;

  return (
    <TagLink
      {...props}
      colorScheme={colorSchemes.keyword}
      href={willIncludeLink ? "/search/company" : undefined}
      onClick={willIncludeLink ? handleKeywordClick : undefined}
    >
      <PermissionField hasPermission={hasPermission}>{keyword}</PermissionField>
    </TagLink>
  );
};

export default KeywordTag;
